// import React from "react";
// import "./Banner_2.css";
// const Banner_2 = () => {
//   return (
//   <>
//   <section className="Banner_section">

//   </section>
//     <div className="banner2">
//       <img
//         src="/assets/About_us/banner2.png"
//         alt="Banner"
//         className="banner2-img"
//       />
//       <div className="banner2-content">
//         <p className="banner2-subtitle">Available on</p>
//         <h2 className="banner2-title">
//           App and Web for your <br /> Convenience
//         </h2>
//         <div className="banner2-buttons">
//           <img src="/assets/About_us/Googleplay.png" alt="Google Play" />
//           <img src="/assets/About_us/appstore.png" alt="App Store" />
//         </div>
//       </div>
//     </div>
//     </>
//   );
// };

// export default Banner_2;

import React from "react";
import "./Banner_2.css";

function Banner_2() {
  return (
    <section className="banner_wrapper">
      <div className="banner_holder">
        <div className="row align-items-center justify-content-center me-0 ms-0">
          <div className="col-lg-5 col-sm-6 col-md-6 order-2 order-lg-1 order-md-1 ">
            <div className="Image-div">
              <img src="/assets/images/banner/mobile-img.png" alt="mobile" className="mobile-img" />
            </div>
          </div>
          <div className="col-lg-5 col-md-6 col-sm-6 order-sm-2 order-md-1" >
            <div className="banner-content-holder">
            <h2 className="available">Available on</h2>
            <h2 className="app-text"> App and Web for your Convenience</h2>

            <div className="button-holder">
              <img src="/assets/About_us/Googleplay.png" alt="Google Play" className="google-play-btn" />
              <img src="/assets/About_us/appstore.png" alt="Google Play" className="google-play-btn"/>
            </div>
          </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner_2;
